var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{staticClass:"d-flex flex-column align-items-center min-vh-100"},[_c('img',{staticClass:"float-left display-3 mr-4 w-50",attrs:{"src":"/img/404.png"}}),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }